// Constants.js

const ENV = (process.env.REACT_APP_ENV || 'production').toLowerCase()

const selectConfig = (development, staging, production) => {
  switch (ENV) {
    case "development":
      return development
    case "staging":
      return staging
    case "production":
      return production
    default:
      console.warn(`Unknown environment: ${ENV}, falling back to development`)
      return development
  }
}

const PROD_PUBLIC_URL = 'https://agenthelper.swifteq.com'
const PROD_API_URL = 'https://agenthelper.swifteq.com/api'
const PROD_LOGIN_URL = 'https://agenthelper.swifteq.com/login'
const PROD_HC_MANAGER_URL = 'https://hcmanager.swifteq.com'

const STAGING_CONNECT_URL = 'https://agenthelper-staging.swifteq.com'
const STAGING_PUBLIC_URL = 'https://agenthelper-staging.swifteq.com'
const STAGING_API_URL = 'https://agenthelper-staging.swifteq.com/api'
const STAGING_LOGIN_URL = 'https://agenthelper-staging.swifteq.com/login'
const STAGING_HC_MANAGER_URL = 'https://hcmanager-staging.swifteq.com'

const DEV_CONNECT_URL = 'https://test.swifteq.com'
const DEV_PUBLIC_URL = 'http://localhost:3000'
const DEV_API_URL = 'http://localhost:3005/api'
const DEV_LOGIN_URL = 'http://localhost:3005/login'
const DEV_HC_MANAGER_URL = 'http://localhost:3001'

const DEV_AUTH = {
  domain: 'auth-dev.swifteq.com',
  clientId: 'ApKuNY9ffZLxhGC5L29nbtl3NLFXWLAE',
  audience: 'https://agenthelp.swifteq.com/api',
}

const STAGING_AUTH = {
  domain: 'auth-dev.swifteq.com',
  clientId: 'ApKuNY9ffZLxhGC5L29nbtl3NLFXWLAE',
  audience: 'https://agenthelp.swifteq.com/api',
}

const PROD_AUTH = {
  domain: 'auth.swifteq.com',
  clientId: 'Ff4n73q6uaE18EtighiN5dXWP6r2rKhM',
  audience: 'https://agenthelp.swifteq.com/api',
}


export const BILLING_PORTAL_URL = 'https://billing.stripe.com/p/login/bIY9Er2Pde1s9uo144'

// The Zendesk MCP Server endpoint given to new users (MCP Streamable HTTP). It is a
// production service, the same in every environment. Connectors set up with the
// previous /api/mcp/sse URL keep working; the setup tabs say so next to the new URL.
export const MCP_SERVER_URL = 'https://mcp.swifteq.com/api/mcp/mcp'
export const MCP_SERVER_LEGACY_URL = 'https://mcp.swifteq.com/api/mcp/sse'

export const CONNECT_URL = selectConfig(DEV_CONNECT_URL, STAGING_CONNECT_URL, PROD_PUBLIC_URL)
export const PUBLIC_URL = selectConfig(DEV_PUBLIC_URL, STAGING_PUBLIC_URL, PROD_PUBLIC_URL)
export const API_URL = selectConfig(DEV_API_URL, STAGING_API_URL, PROD_API_URL)
export const LOGIN_URL = selectConfig(DEV_LOGIN_URL, STAGING_LOGIN_URL, PROD_LOGIN_URL)
export const HC_MANAGER_URL = selectConfig(DEV_HC_MANAGER_URL, STAGING_HC_MANAGER_URL, PROD_HC_MANAGER_URL)

export const AUTH_CONFIG = selectConfig(DEV_AUTH, STAGING_AUTH, PROD_AUTH)


export const TRANSLATE_LANGUAGES = [
  "English",
  "German",
  "French",
  "Spanish",
  "Italian",
  "Portuguese",
  "Dutch",
  "Polish",
  "Russian",
  "Turkish",
  "Japanese",
  "Chinese",
  "Korean",
  "Arabic",
  "Hebrew",
  "Hindi",
  "Thai",
  "Vietnamese",
  "Indonesian",
  "Malay",
  "Swedish",
  "Norwegian",
  "Danish",
  "Finnish",
  "Icelandic",
  "Greek",
  "Czech",
  "Slovak",
  "Hungarian",
  "Romanian",
  "Bulgarian",
  "Ukrainian",
  "Croatian",
  "Serbian",
  "Slovenian",
  "Lithuanian",
  "Latvian",
  "Estonian",
  "Albanian",
  "Macedonian",
]

export const LOCAL_APPS = ['mergedup', 'redact', 'triggers_gpt', 'classify', 'lookup', 'document_parser', 'translate', 'cowriter', 'macroexport', 'easydoc', 'answersearch', 'macrosearch', 'exportPdfs', 'mcpserver', 'resolveloop', 'admin']
